<template>
    <div style="position: relative;" @click="clickEvent">
        <div style="position: absolute; top: 50%; transform: translateY(-50%); left: 12px;">
            <img style="width: 16px;" :src="require('@/assets/img/merc_search.png')" alt="">
        </div>
        <div style="display: flex; align-items: center; gap: 12px;">
            <input @keyup="setSearchWordBefore($event)" :value="searchWord" :placeholder="placeholder" style="flex: 1; background-color: #f5f5f5; outline: none; border: none; border-radius: 12px; padding: 8px 0; padding-left: 36px;" type="text" enterkeyhint="search">
            <div v-if="isShowCancelBtn" @click.stop="clickCancel" style="font-weight: 700; font-size: 14px; color: var(--color-main);">취소</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "MercenarySearchInput",
    props: {
        placeholder: {
            type: String,
            default: ''
        },
        clickEvent: {
            type: Function,
            default: () => { }
        },
        clickCancel: {
            type: Function,
            default: () => { }
        },
        isShowCancelBtn: {
            type: Boolean,
            default: false,
        },
        setSearchWord: {
            type: Function,
            default: () => { }
        },
        searchWord: {
            type: String,
            default: ''
        },
        enter: {
            type: Function,
            default: () => { }
        }
    },
    data() {
        return {
            componentsSearchWord: ''
        }
    },
    methods: {
        setSearchWordBefore(e) {
            this.enter(e)
        },

    }
}
</script>

<style scoped>
input::placeholder {
    font-size: 14px;
    font-weight: 500;
    color: #bbbbbb;
}
</style>